import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import FeedbackForm from '@/components/feedback/FeedbackForm.vue';
import { Feedback } from '@/models/feedback.model';
import { Mutations, ShiftCMSState } from '@/store';
import { FeedbackActions, FeedbackState } from '@/stores/feedback.store';
import { computed, markRaw, onBeforeUnmount, onMounted } from 'vue';
import { useStore } from 'vuex';
import { format } from 'date-fns';


export default /*@__PURE__*/_defineComponent({
  __name: 'FeedbackList',
  setup(__props) {

const store = useStore<ShiftCMSState & { fs: FeedbackState }>();
const feedback = computed<Feedback[]>(() => store.state.fs.feedback);

const update = () => {
  store.dispatch(FeedbackActions.GetFeedback);
};

onMounted(() => {
  update();
});

onBeforeUnmount(() => {
  store.commit(Mutations.HideDrawer);
});

const showFeedback = (_: Event, { item }: { item: Feedback }) => {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(FeedbackForm),
    data: item,
  });
};

const headers = [
  { title: 'ID', key: 'id', sortable: false },
  { title: 'Message', key: 'message' },
  { title: 'Resolved', key: 'resolved' },
  { title: 'User', key: 'user.name' },
  { title: 'Date', key: 'creationDate' },
];

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _cache[0] || (_cache[0] = _createElementVNode("h2", null, "Feedback", -1)),
      _createVNode(_component_v_data_table, {
        density: "compact",
        "onClick:row": showFeedback,
        headers: headers,
        items: feedback.value,
        itemsPerPage: "25",
        sortBy: [{ key: 'creationDate', order: 'desc' }],
        hover: ""
      }, {
        "item.creationDate": _withCtx(({ value }) => [
          _createTextVNode(_toDisplayString(_unref(format)(value, 'do MMMM yyyy - HH:mm')), 1)
        ]),
        "item.resolved": _withCtx(({ value }) => [
          value
            ? (_openBlock(), _createBlock(_component_v_icon, {
                key: 0,
                icon: "mdi-check"
              }))
            : _createCommentVNode("", true),
          (!value)
            ? (_openBlock(), _createBlock(_component_v_icon, {
                key: 1,
                icon: "mdi-circle-off-outline"
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["items"])
    ]),
    _: 1
  }))
}
}

})